import moment from "moment";

import { ObjectRegistry } from '@lts-web/registry';
import { CalendarList, DateEventList } from '@lts-web/list-objects';
import { CalendarData, DateEventData } from '@lts-web/data-objects';

const calendarRegistry = new ObjectRegistry(CalendarList);
const dateEventRegistry = new ObjectRegistry(DateEventList);

export const roundMinutes = (date, duration) => {
    date = moment(date);
    const remainder = duration - (date.minute() % duration);
    return date.add(remainder, 'minutes');
};

export const formatDate = (date, format, formatFrom) => {
    return moment(date, formatFrom).format(format);
};

export const addDateEvent = (type, dateEvent) => {
    if (!(dateEvent instanceof DateEventData)) {
        throw new TypeError('Second argument must be of instance `DateEventData`');
    }

    const dateEventList = getDateEventList(type);
    const hasDateEvent = dateEventList.getDateEventByCode(dateEvent.getCode());

    if (!dateEventList || hasDateEvent) {
        return false;
    }

    dateEventList.addDateEvent(dateEvent);
    return true;
};

export const getDateEvent = (type, dateEventName) => {
    const dateEventList = getDateEventList(type);

    if (!dateEventList) {
        return null;
    }

    return dateEventList.getDateEvent(dateEventName);
};

export const getDateEventByName = (type, dateEventName) => {
    const dateEventList = getDateEventList(type);

    if (!dateEventList) {
        return null;
    }

    return dateEventList.getDateEventByName(dateEventName);
};

export const addCalendarLink = (calendarList, date, link, priority, returnAvailability, availability) => {
    if (!(calendarList instanceof CalendarList)) {
        throw new TypeError('Second argument must be of instance `DateEventData`');
    }

    let calendarData = calendarList.getCalendarData(date);

    if (!calendarData) {
        calendarData = calendarList.addCalendarData(new CalendarData({
            date,
            availability
        }));
    }

    return calendarData.addLink(link, priority, returnAvailability);
};

export const getCalendarData = (type, date) => {
    const calendarList = getCalendarList(type);

    if (!calendarList) {
        return null;
    }

    return calendarList.getCalendarData(date);
};

export const createDateEventList = (type, list) => dateEventRegistry.set(type, new DateEventList(type, list));

export const getDateEventList = (type) => dateEventRegistry.get(type);

export const hasDateEventList = (type) => dateEventRegistry.has(type);

export const removeDateEventList = (type) => dateEventRegistry.delete(type);

export const createCalendarList = (type, list) => calendarRegistry.set(type, new CalendarList(type, list));

export const getCalendarList = (type) => calendarRegistry.get(type);

export const hasCalendarList = (type) => calendarRegistry.has(type);

export const removeCalendarList = (type) => calendarRegistry.delete(type);

export default class DatesUtil {
    static roundMinutes = roundMinutes;
    static formatDate = formatDate;
    static addDateEvent = addDateEvent;
    static getDateEvent = getDateEvent;
    static getDateEventByName = getDateEventByName;
    static addCalendarLink = addCalendarLink;
    static getCalendarData = getCalendarData;
    static createDateEventList = createDateEventList;
    static getDateEventList = getDateEventList;
    static hasDateEventList = hasDateEventList;
    static removeDateEventList = removeDateEventList;
    static createCalendarList = createCalendarList;
    static getCalendarList = getCalendarList;
    static hasCalendarList = hasCalendarList;
    static removeCalendarList = removeCalendarList;
}